/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react';
import ReCaptchaV2 from "react-google-recaptcha";

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useForm, useField } from 'react-final-form-hooks';
import {
  Button,
  Checkbox,
  Container,
  Error,
  Input,
  Label,
  Modal,
  ModalTypical,
  Select
} from 'app/components';
import {
  getPostValidationError,
  getPreValidationError,
  getPreValidationDropdownError,
  getPreValidationFieldError
} from 'app/utils';
import { useConfig, useEffectFormReset, useModal } from 'app/hooks';
import { Title, NewsletterWrapper } from './styles';
import { NavLink } from 'react-router-dom';

const propTypes = {
  validateWithSchema: PropTypes.func.isRequired,
  notify: PropTypes.func.isRequired,
  legalInfo: PropTypes.arrayOf(
    PropTypes.shape({
      doc: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    })
  ).isRequired,
  newsletterResult: PropTypes.string,
  sendNewsletterRegistration: PropTypes.func.isRequired
};

const defaultProps = {
  newsletterResult: ''
};

const validatingTermsConditions = field => {
  return (
    !field.input.value.includes('terms and conditions') ||
    !field.input.value.includes('privacy policy')
  );
};

const Newsletter = ({
  validateWithSchema,
  notify,
  legalInfo,
  newsletterResult,
  sendNewsletterRegistration,
}) => {
  const [t] = useTranslation();
  const {
    media: { docsPrefix },
    routes
  } = useConfig();
  const captchaRef = useRef(null);
  const [recaptchaStatus, setRecaptchaStatus] = useState(-1);
  const [reCaptchaMsg, setReCaptchaMsg] = useState(true);
  const [recaptchaError, setRecaptchaError] = useState(null);
  const handleRecaptha = async () => {
    const token = captchaRef.current.getValue();
    const data = await fetch(`https://www.google.com/recaptcha/api/siteverify`, {
      method: "POST",
      // mode: 'no-cors',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
      },
      body: `secret=${process.env.REACT_APP_SECRET_KEY}&response=${token}`,
    }
    )
    setRecaptchaStatus(data?.status);
  }

  async function verifyCaptcha(captcha) {
    const verifyEndpoint = "https://www.google.com/recaptcha/api/siteverify";
    try {
      const response = await fetch(verifyEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
        },
        body: `secret=${process.env.REACT_APP_SECRET_KEY}&response=${captcha}`,
      });


      if (!response.ok) {
        throw new Error("Failed to verify CAPTCHA");
      }

      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error("CAPTCHA verification failed:", error);
      return false;
    }
  };

  const handleRecaptcha = async () => {
    const token = captchaRef.current.getValue();
    try {
      const result = await verifyCaptcha(token);
      setReCaptchaMsg(result);
      setRecaptchaError("");
    } catch (error) {
      console.error("Error during CAPTCHA verification:", error);
      setRecaptchaError('CAPTCHA verification failed.');
    }
  };

  const handleExpired = () => {
    // setRecaptchaError('Verification expired. Check the checkbox again.');
    setRecaptchaError(t("common.recaptcha_error"));
    setReCaptchaMsg(true)
    setTimeout(() => {
      captchaRef.current.reset();
    }, 100)
  };

  const sendRegistration = async (values) => {
    captchaRef.current.reset();
    setRecaptchaStatus(-1);
    const {
      salutation,
      firstName,
      lastName,
      company,
      email,
      phoneNumber,
      zipCode,
      city,
      street
    } = values;
    const payload = {
      salutation: salutation?.[0]?.value || '',
      firstName: firstName || '',
      lastName: lastName || '',
      company: company || '',
      email: email || '',
      phoneNumber: phoneNumber || '',
      zip: zipCode || '',
      city: city || '',
      street: street || ''
    };

    sendNewsletterRegistration(payload);
  };

  const {
    form,
    handleSubmit,
    submitErrors: errors,
    submitSucceeded,
    submitting,
    submitFailed
  } = useForm({
    onSubmit: sendRegistration,
    validate: validateWithSchema
  });

  const salutation = useField('salutation', form);
  const firstName = useField('firstName', form);
  const lastName = useField('lastName', form);
  const company = useField('company', form);
  const email = useField('email', form);
  const phoneNumber = useField('phoneNumber', form);
  const zipCode = useField('zipCode', form);
  const city = useField('city', form);
  const street = useField('street', form);
  const terms = useField('terms', form);

  const salutationOptions = useMemo(
    () => [
      { label: t('common.mr'), value: 'Mr.', key: 'mr.' },
      { label: t('common.mrs'), value: 'Mrs.', key: 'mrs.' }
    ],
    []
  );

  const [legalInfoList, setLegalInfoList] = useState([]);

  const [isShowSuccess, showSuccess, hideSuccess] = useModal('success');

  useEffect(() => {
    if (legalInfo?.length) {
      const list = legalInfo.filter(item => process.env.REACT_APP_COUNTRY === "srb" ? [6, 1].some(value => value === +item.docType) : process.env.REACT_APP_COUNTRY === "mne" ? [3, 5].some(value => value === +item.docType) : [1, 3].some(value => value === +item.docType));

      setLegalInfoList(list);
    }
  }, [legalInfo]);

  // useEffect(() => {
  //   if (newsletterResult === 'success') showSuccess();
  // }, [newsletterResult]);
  useEffect(() => {
    if (submitSucceeded) {
      showSuccess();
    }
  }, [submitSucceeded]);

  useEffect(() => {
    if (submitFailed) {
      notify('warning', t('common.post_validation_error'));
    }
  }, [submitFailed]);

  useEffectFormReset(form, errors, submitSucceeded, submitting);

  const handleTermsChange = useCallback(
    item => {
      const termList = [...terms.input.value];

      if (Array.isArray(termList)) {
        if (termList.includes(item)) {
          termList.splice(termList.indexOf(item), 1);
        } else {
          termList.push(item);
        }
      } else {
        termList.push(item);
      }
      form.change(terms.input.name, termList);
    },
    [terms.input.value]
  );


  return (
    <Container>
      <Title>{t('common.newsletter_registration')}</Title>
      <NewsletterWrapper onSubmit={handleSubmit} as="form">
        <h3>{t('common.newsletter_reg_subtitle')}</h3>
        <div className="newsletter-wrapper__data-divider" />
        <div className="newsletter-wrapper__input-wrapper">
          <h2>{t('cinema_rent_inquiry_form.data')}</h2>
          <div className="newsletter-wrapper__input-container">
            <div className="newsletter-wrapper__input-reg-s">
              <Label>{t('common.salutation')}*</Label>
              <Select
                placeholder={t('common.choose')}
                options={salutationOptions}
                error={
                  getPreValidationDropdownError(salutation, t) ||
                  getPostValidationError(errors, salutation.input.name, t)
                }
                onDropdownClose={() => {
                  form.getFieldState(salutation.input.name).blur();
                }}
                onChange={value => {
                  form.change(salutation.input.name, value);
                }}
              />
              {submitFailed && (salutation.meta?.error || !salutation.input.value.includes('')) && (
                <Error>
                  {(salutation.meta?.error && t(salutation.meta?.error))}
                </Error>
              )}
            </div>
            <div className="newsletter-wrapper__input-dual">
              <div className="newsletter-wrapper__input-reg-s">
                <Label>{t('common.first_name')} *</Label>
                <Input
                  id={firstName.input.name}
                  {...firstName.input}
                  error={
                    getPreValidationFieldError(firstName, t) ||
                    getPostValidationError(errors, firstName.input.name, t)
                  }
                />
                {submitFailed && (firstName.meta?.error || !firstName.input.value.includes('')) && (
                  <Error>
                    {(firstName.meta?.error && t(firstName.meta?.error))}
                  </Error>
                )}
              </div>
              <div className="newsletter-wrapper__input-reg">
                <Label>{t('common.last_name')} *</Label>
                <Input
                  id={lastName.input.name}
                  {...lastName.input}
                  error={
                    getPreValidationFieldError(lastName, t) ||
                    getPostValidationError(errors, lastName.input.name, t)
                  }
                />
                {submitFailed && (lastName.meta?.error || !lastName.input.value.includes('')) && (
                  <Error>
                    {(lastName.meta?.error && t(lastName.meta?.error))}
                  </Error>
                )}
              </div>
            </div>
            <div className="newsletter-wrapper__input-reg-s">
              <Label>{t('common.company')}</Label>
              <Input
                id={company.input.name}
                {...company.input}
                error={
                  getPreValidationFieldError(company, t) ||
                  getPostValidationError(errors, company.input.name, t)
                }
              />
            </div>
            <div className="newsletter-wrapper__input-dual">
              <div className="newsletter-wrapper__input-reg-s">
                <Label>{t('form.email')} *</Label>
                <Input
                  id={email.input.name}
                  {...email.input}
                  error={
                    // getPreValidationFieldError(email, t) ||
                    getPreValidationError(email, t) ||
                    getPostValidationError(errors, email.input.name, t)
                  }
                />
                {submitFailed && (email.meta?.error || !email.input.value.includes('')) && (
                  <Error>
                    {(email.meta?.error && t(email.meta?.error))}
                  </Error>
                )}
              </div>
              <div className="newsletter-wrapper__input-reg">
                <Label>{t('cinema_rent_inquiry_form.phone_number')}</Label>
                <Input
                  id={phoneNumber.input.name}
                  {...phoneNumber.input}
                  error={
                    getPreValidationFieldError(phoneNumber, t) ||
                    getPostValidationError(errors, phoneNumber.input.name, t)
                  }
                />
              </div>
            </div>
            <div className="newsletter-wrapper__input-dual">
              <div className="newsletter-wrapper__input-reg-s">
                <Label>{t('cinema_rent_inquiry_form.zip_code')} *</Label>
                <Input
                  id={zipCode.input.name}
                  {...zipCode.input}
                  error={
                    getPreValidationFieldError(zipCode, t) ||
                    getPostValidationError(errors, zipCode.input.name, t)
                  }
                />
                {submitFailed && (zipCode.meta?.error || !zipCode.input.value.includes('')) && (
                  <Error>
                    {(zipCode.meta?.error && t(zipCode.meta?.error))}
                  </Error>
                )}
              </div>
              <div className="newsletter-wrapper__input-reg">
                <Label>{t('form.city')} *</Label>
                <Input
                  id={city.input.name}
                  {...city.input}
                  error={
                    getPreValidationFieldError(city, t) ||
                    getPostValidationError(errors, city.input.name, t)
                  }
                />
                {submitFailed && (city.meta?.error || !city.input.value.includes('')) && (
                  <Error>
                    {(city.meta?.error && t(city.meta?.error))}
                  </Error>
                )}
              </div>
            </div>
            <div className="newsletter-wrapper__input-lng">
              <Label>{t('cinema_rent_inquiry_form.street_number')}</Label>
              <Input
                id={street.input.name}
                {...street.input}
                error={
                  getPreValidationFieldError(street, t) ||
                  getPostValidationError(errors, street.input.name, t)
                }
              />
            </div>
          </div>
          <div className="newsletter-wrapper__checkbox-wrapper">
            {
              process.env.REACT_APP_COUNTRY === "hrv" ?
                "" :
                (
                  <Label className="newsletter-wrapper__input-checkbox">
                    <Checkbox
                      id="terms and conditions"
                      value={terms.input.value?.includes('terms and conditions')}
                      checked={terms.input.value?.includes('terms and conditions')}
                      onChange={() => handleTermsChange('terms and conditions')}
                    />
                    <h3>
                      {t('cinema_rent_inquiry_form.yes_accept')} *{' '}
                      <a
                        href={docsPrefix(legalInfoList[process.env.REACT_APP_COUNTRY === "srb" ? 1 : 0]?.doc)}
                        className="newsletter-wrapper__terms-link"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {t('common.read_more')}
                      </a>
                    </h3>
                  </Label>
                )
            }
            <Label className="newsletter-wrapper__input-checkbox">
              <Checkbox
                id="privacy policy"
                value={terms.input.value?.includes('privacy policy')}
                checked={terms.input.value?.includes('privacy policy')}
                onChange={() => handleTermsChange('privacy policy')}
              />
              <h3>
                {t('cinema_rent_inquiry_form.yes_note')} *{' '}
                <a
                  href={docsPrefix(legalInfoList[process.env.REACT_APP_COUNTRY === "srb" ? 0 : 1]?.doc)}
                  className="newsletter-wrapper__terms-link"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {t('common.read_more')}
                </a>
              </h3>
            </Label>
            {submitFailed && (terms.meta?.error || validatingTermsConditions(terms)) && (
              <Error>
                {(terms.meta?.error && t(terms.meta?.error)) || t('common.select_value_error')}
              </Error>
            )}
          </div>
          <h3 className="newsletter-wrapper__required-fields">
            * {t('cinema_rent_inquiry_form.required_fields')}
          </h3>
        </div>
        <div className="newsletter-wrapper__register-divider" />
        <div className="newsletter-wrapper__register-btn">
          <div className='captcha'>
            <ReCaptchaV2
              sitekey={process.env.REACT_APP_SITE_KEY}
              ref={captchaRef}
              onChange={() => handleRecaptcha()}
              theme="dark"
              onExpired={handleExpired}
            />
            {recaptchaError && <div style={{ color: 'red', marginTop: "10px" }}>{recaptchaError}</div>}
          </div>
          <Button
            type="submit"
            isPrimary
            className="register-btn"
            disabled={!(terms?.input?.value.includes('terms and conditions') && terms?.input?.value?.includes('privacy policy') && !reCaptchaMsg)}
          >
            {t('common.register')}
          </Button>
        </div>
      </NewsletterWrapper>
      <Modal
        isSmall
        isOpen={isShowSuccess}
        // close={hideSuccess} 
        title={t('common.success')}>
        <ModalTypical iconId="complete" message={t('common.b2b_newsletter_success')}>
          <NavLink NavLink to={routes.movies.pattern} style={{ width: '100%' }}>
            <Button style={{ width: '200px' }} isPrimary onClick={hideSuccess}>
              {t('common.ok')}
            </Button>
          </NavLink>
        </ModalTypical>
      </Modal>
    </Container>
  );
};

Newsletter.propTypes = propTypes;
Newsletter.defaultProps = defaultProps;

export default Newsletter;
